import { element } from 'protractor';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatPaginator, MatSort, MatPaginatorIntl, Sort } from '@angular/material';
import { ManageUsersDialogComponent } from '../manage-users-dialog/manage-users-dialog.component';
import { Subscription } from 'rxjs';
import { ParemployeeDocumentDeleteDialogComponent } from '../paremployee-document-delete-dialog/paremployee-document-delete-dialog.component';
import { ManageUserDeleteDialogueComponent } from '../manage-user-delete-dialogue/manage-user-delete-dialogue.component';
import { ManageUsersService } from '../../services/manage-users/manage-users.service';
import { PageEvent } from '@angular/material';
import { Subject } from 'rxjs/Subject'
@Component({
  selector: 'app-manage-users',
  templateUrl: './manage-users.component.html',
  styleUrls: ['./manage-users.component.css']
})
export class ManageUsersComponent implements OnInit {
  length: any;
  message: string;
  ispaginationFlag: boolean = false;
  EmployeeData: any[] = [];
  roles: any;
  siteAdminList: any = [];
  FilteredData: any[] = [];
  pageSize = 10;
  DocListErr: boolean = false;
  DocListErrMsg;
  isActive: boolean = true;
  BlockedUser: boolean = true;
  activeFlag: boolean = false;
  clientHidden: any;
  pageEvent: PageEvent;
  QACRoleToVendor: any;
  refresh: Subject<any>;
  abc: any;
  data: any = {
    docId: '',
    vendor_name: '',
    master_vendor_id: 0,
    master_vendor_name: '',
    first_name: '',
    last_name: '',
    middle_name: '',
    email_id: '',
    role: '',
    isActive: '',
    created_by: '',
    updated_by: '',
    blocked_user: '',
  };
  tempsiteAdminList: any[];
  constructor(public dialog: MatDialog, private manageUsersService: ManageUsersService) {
    this.refresh = new Subject();
  }

  private subscription: Subscription;
  displayedColumns = ['FirstName', 'Email', 'BlockedUser', 'CreatedTimeStamp', 'Role', 'MasterVendorName', 'FileEdit']; // 'IsActive', BlockedUser 'Role',
  dataSource: MatTableDataSource<SiteAdmin>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  ngOnInit() {
    this.getSiteAdminData();
    this.getRoles();
    this.subscription = this.manageUsersService.load.subscribe(res => {
      if (res === 'success') {
        this.data.role = '';
        this.getSiteAdminData();
      }
    });
  }
  selectedRole(role) {
    // this.refresh.next(role)
    this.siteAdminList = this.tempsiteAdminList.filter(x => {
      return x.Role.toLowerCase() === role.toLowerCase()
    })
    this.dataSource = new MatTableDataSource(this.siteAdminList);
    this.paginator.pageIndex=0;
    this.doPaginate();
  }

  getSiteAdminData() {
    this.manageUsersService.getAllSiteAdminUser().subscribe(res => {
      if (res.Status == 200 && res.Users.length == 0) {
        this.siteAdminList = [];
        this.dataSource = null;
        this.message = 'No users found';
        this.ispaginationFlag = false;
      } else if (res.Status === 200 && res.Users.length > 0 && res.Users !== undefined) {
        this.siteAdminList = [];
        for (let i = 0; i < res.Users.length; i++) {
          if (res.Users[i].FirstName != null && res.Users[i].LastName != null && res.Users[i].Email != null) {
            res.Users[i].FirstName = res.Users[i].FirstName;
            res.Users[i].LastName = res.Users[i].LastName;
            res.Users[i].Email = res.Users[i].Email;
            if (res.Users[i].MasterVendorName != undefined && res.Users[i].MasterVendorName != '') {
              res.Users[i].MasterVendorName = res.Users[i].MasterVendorName;
            } else
              res.Users[i].MasterVendorName = res.Users[i].MasterVendorName;
            this.siteAdminList.push(res.Users[i]);
          }
        }
        this.siteAdminList.forEach(function (item) {
          if (item.Role === 'QAC') {
            item.Role = 'PAR Vendor Relations';
          } if (item.Role === 'PARManager') {
            item.Role = 'PAR Manager';
          } if (item.Role === 'PARAdmin') {
            item.Role = 'PAR Admin';
          } if (item.Role === 'SiteAdmin') {
            item.Role = 'Site Admin';
          } if (item.Role === 'Vendor') {
            item.Role = 'Recovery Vendor';
          } if (item.Role === 'ResolutionManager') {
            item.Role = 'Resolution Manager';
          }
        });
        this.siteAdminList.forEach(function (item) {
          if (item.IsActive === 'Y') {
            item.IsActive = true;
          } else {
            item.IsActive = false;
          }
        });
        this.siteAdminList.forEach(function (item) {
          if (item.BlockedUser === 'Y') {
            item.BlockedUser = true;
          } else {
            item.BlockedUser = false;
          }
        });
        this.tempsiteAdminList = this.siteAdminList;
        this.message = '';
        this.dataSource = new MatTableDataSource(this.siteAdminList);
        //To implement pagination
        this.doPaginate()
      }
    },
      err => {
        this.DocListErrMsg = 'Site Admin Users' + err;
        this.DocListErr = false;
      });
  }

  doPaginate() {
    this.dataSource.sort = this.sort;
    this.length = this.siteAdminList.length;
    if (this.length <= 10) {
      this.ispaginationFlag = false;
    } else {
      this.ispaginationFlag = true;
    }
    if (this.paginator.pageIndex > 0 && (this.length % 10 === 0)) {
      this.paginator.pageIndex = this.paginator.pageIndex - 1;
    }
    this.dataSource.paginator = this.paginator;
    const paginatorIntl = new MatPaginatorIntl();
    paginatorIntl.itemsPerPageLabel = 'Items per page';
    paginatorIntl.nextPageLabel = 'Next page';
    paginatorIntl.previousPageLabel = 'Previous page';
    paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      length = this.length;
      if (length === 0 || pageSize === 0) { return `0 van ${length}`; }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex = startIndex < length ?
        Math.min(startIndex + pageSize, length) :
        startIndex + pageSize;
      const round = Math.ceil(length / 10)
      return `${(startIndex / 10) + 1}  of ${round}`;
    };
    this.dataSource.paginator._intl = paginatorIntl;
  }

  addSiteAdmin(): void {
    this.activeFlag = false;
    const dialogRef = this.dialog.open(ManageUsersDialogComponent, {
      width: '40%',
      height: '75%',
      data: { status: 'create' }
    });
  }
  editSiteAdmin(siteAdmin) {
    this.activeFlag = true;
    const dialogRef = this.dialog.open(ManageUsersDialogComponent, {
      disableClose: true,
      width: '40%',
      height: '75%',
      data: { data: siteAdmin, status: 'update' }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  deleteDoc(data) {
    const dialogRef = this.dialog.open(ManageUserDeleteDialogueComponent, {
      width: '400px',
      height: '250px',
      data: data._id
    });
  }
  getRoles() {
    this.manageUsersService.getRoles().subscribe(res => {
      this.roles = res.Roles;
      /*this.QACRoleToVendor = JSON.parse(
        JSON.stringify(res, function (key, value) {
          return value.Roles[1].Code === 1 ? value.Roles[1].Role = 'PAR Vendor Relations' : value;
        })
      );
      JSON.parse(
        JSON.stringify(res, function (key, value) {
          return value.Roles[2].Code === 2 ? value.Roles[2].Role = 'PAR Manager' : value;
        })
      );
      JSON.parse(
        JSON.stringify(res, function (key, value) {
          return value.Roles[3].Code === 4 ? value.Roles[3].Role = 'PAR Admin' : value;
        })
      );
      JSON.parse(
        JSON.stringify(res, function (key, value) {
          return value.Roles[0].Code === 16 ? value.Roles[0].Role = 'Site Admin' : value;
        })
      );
      JSON.parse(
        JSON.stringify(res, function (key, value) {
          return value.Roles[5].Code === 32 ? value.Roles[5].Role = 'Recovery Vendor' : value;
        })
      );
      JSON.parse(
        JSON.stringify(res, function (key, value) {
          return value.Roles[7].Code === 128 ? value.Roles[7].Role = 'Resolution Manager' : value;
        })
      );*/
      for(let x =0; x<this.roles.length; x++) {
        if (this.roles[x].Code === 1) {
          this.roles[x].Role = 'PAR Vendor Relations';
        } else if (this.roles[x].Code === 2) {
          this.roles[x].Role = 'PAR Manager';
        } else if (this.roles[x].Code === 4) {
          this.roles[x].Role = 'PAR Admin';
        } else if (this.roles[x].Code === 16) {
          this.roles[x].Role = 'Site Admin';
        } else if (this.roles[x].Code === 32) {
          this.roles[x].Role = 'Recovery Vendor';
        } else if (this.roles[x].Code === 128) {
          this.roles[x].Role = 'Resolution Manager';
        }
      }
    });
  }


}

export interface SiteAdmin {
  FirstName: String;
  Email: string;
  BlockedUser: string;
  Role: string;
  CreatedTimeStamp: Date;
  FileEdit: any;
  MasterVendorName: String;
}



// WEBPACK FOOTER //
// ./src/app/components/manage-users/manage-users.component.ts